import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import Dashboarddata from "./Dashboarddata";
import AdminFooter from "./AdminFooter";

import Categories from "./Categories";
import AllProjects from "./AllProjects";
import AddProject from "./AddProject";

import { Container, Row, Col, Button, Offcanvas } from "react-bootstrap";
import "../Assets/WebsiteCss/Dashboard.css";

export default function Dashboard() {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="dashboard-container">
      <Container fluid className="p-0">
        <Row className="g-0">
          {/* MOBILE SIDEBAR - Only on mobile */}
          <Offcanvas
            show={showSidebar}
            onHide={() => setShowSidebar(false)}
            placement="start"
            className="d-md-none"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
              <Sidebar />
            </Offcanvas.Body>
          </Offcanvas>

          {/* DESKTOP SIDEBAR - Only on desktop */}
          <Col md={2} className="d-none d-md-block sidebar-wrapper">
            <Sidebar />
          </Col>

          {/* MAIN CONTENT */}
          <Col xs={12} md={10} className="main-content-wrapper">
            {/* Mobile Menu Button */}
            <div className="d-md-none mobile-menu-header">
              <button
                className="mobile-menu-btn"
                onClick={() => setShowSidebar(true)}
              >
                <span className="menu-icon">☰</span>
                <span className="menu-text">Menu</span>
              </button>
            </div>

            <Topbar />

            {/* 🔥 ADMIN ROUTES */}
            <Routes>
              <Route index element={<Dashboarddata />} />

              <Route path="categories" element={<Categories />} />

              <Route path="projects" element={<AllProjects />} />
              <Route path="add-project" element={<AddProject />} />

              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </Col>
        </Row>

        <AdminFooter />
      </Container>
    </div>
  );
}
